export const baseUrl = "https://hccquangha-api.mobifone5.vn/hccqh"
//export const baseUrl = "https://api-bhtt.mobifone5.vn/api-bhtt"
//export const baseUrl = "https://apiungdunganm.haiduong.gov.vn/anm"
export default {
    baseUrl
}
